import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'Manufacturers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (!this.hasAdministratorOperationalAccessUi())
                this.logout();
        }

        this.GetInfo();
    },

    mounted() {
        const el = document.getElementById('offcanvasManufacturerForm');
        if (el) {
            el.addEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    beforeDestroy() {
        const el = document.getElementById('offcanvasManufacturerForm');
        if (el) {
            el.removeEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    computed: {
        /** نفس حارس الخادم: إدارة الصيدلة ومدير النظام. */
        canLicenseUi() {
            return !!(this.loginDetails && this.hasAdministratorOperationalAccessUi());
        },
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        drawerTitle() {
            return this.drawerMode === 'create'
                ? `إضافة ${this.ScreenTitleSingle}`
                : `تعديل ${this.ScreenTitleSingle}`;
        },
        drawerSubtitle() {
            return this.drawerMode === 'create'
                ? 'أدخل بيانات الشركة المصنعة الجديدة.'
                : 'حدّث بيانات الشركة المصنعة من اللوحة الجانبية مباشرة.';
        },
        drawerSubmitLabel() {
            return this.drawerMode === 'create'
                ? `إضافة ${this.ScreenTitleSingle}`
                : 'حفظ التعديلات';
        },
        drawerDescription() {
            return this.drawerMode === 'create'
                ? 'سيتم تفعيل الشركة المصنعة مباشرة بعد الحفظ، ويمكنك إخفاؤها لاحقاً من قائمة الإجراءات.'
                : 'يمكنك تعديل الاسم والوصف، بينما تغيير حالة العرض يتم من قائمة الإجراءات داخل الجدول.';
        },
        currentStatusText() {
            if (this.drawerMode === 'create') return 'سيُفعّل مباشرة';
            return this.statusLabel(this.SelectedItem ? this.SelectedItem.status : 1);
        },
        currentStatusClass() {
            return this.statusBadgeClass(
                this.drawerMode === 'create' ? 1 : (this.SelectedItem ? this.SelectedItem.status : 1)
            );
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) return 'فارغ';
            return moment(date).format('DD/MM/YYYY');
        },
        momentDate: function (date) {
            if (!date) return 'فارغ';
            return moment(date).format('DD/MM/YYYY');
        },
        momentTime: function (date) {
            if (date === null) return 'فارغ';
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            // قرار الترخيص — إدارة الصيدلة ومدير النظام
            licenseDialog: false,
            licenseSaving: false,
            licenseForm: { id: 0, name: '', licenseStatus: 1, licenseNumber: '', licenseExpiryOn: '', licenseNote: '' },

            // ترتيب وفلترة المراجعة: '' = الأحدث إدراجاً (كما كان) · 'products' = الأكثر منتجات
            sortBy: '',
            licenseFilter: '',
            reviewLoad: null,

            ScreenTitle: 'الشركات المصنعة',
            ScreenTitleSingle: 'شركة مصنعة',
            ScreenTitleSingleAl: 'الشركة المصنعة',

            Info: [],
            Statistics: [],

            SelectedItem: null,
            drawerMode: 'create',

            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
            },
            rules: {
                Name: this.$helper.Required(),
            },
        };
    },

    methods: {
        /* ── الترخيص ───────────────────────────────────────────── */

        licenseLabel(item) {
            const s = Number(item && item.licenseStatus);
            if (this.isLicenseExpired(item)) return 'رخصة منتهية';
            if (s === 1) return 'مرخّصة';
            if (s === 2) return 'غير مرخّصة';
            return 'لم تُراجع بعد';
        },

        licenseBadgeClass(item) {
            const s = Number(item && item.licenseStatus);
            if (this.isLicenseExpired(item)) return 'bg-label-danger';
            if (s === 1) return 'bg-label-success';
            if (s === 2) return 'bg-label-danger';
            return 'bg-label-warning';
        },

        /** المنتهية تُحجب فعلياً من قائمة الاختيار وإن بقيت حالتها «مرخّصة». */
        isLicenseExpired(item) {
            if (!item || !item.licenseExpiryOn) return false;
            return moment(item.licenseExpiryOn).endOf('day').isBefore(moment());
        },

        expiryClass(item) {
            if (this.isLicenseExpired(item)) return 'text-danger fw-semibold';
            if (item.licenseExpiryOn
                && moment(item.licenseExpiryOn).diff(moment(), 'days') <= 60) return 'text-warning fw-semibold';
            return 'text-muted';
        },

        /** الفرز يعيد الترقيم للصفحة الأولى — وإلا عُرضت صفحة من ترتيب آخر. */
        setSort(value) {
            this.sortBy = this.sortBy === value ? '' : value;
            this.GetInfo(1);
        },

        setLicenseFilter(value) {
            this.licenseFilter = this.licenseFilter === value ? '' : value;
            this.GetInfo(1);
        },

        openLicenseDialog(item) {
            this.licenseForm = {
                id: item.id,
                name: item.name || '',
                licenseStatus: Number(item.licenseStatus || 0),
                licenseNumber: item.licenseNumber || '',
                licenseExpiryOn: item.licenseExpiryOn ? moment(item.licenseExpiryOn).format('YYYY-MM-DD') : '',
                licenseNote: item.licenseNote || '',
            };
            this.licenseDialog = true;
        },

        submitLicense() {
            if (Number(this.licenseForm.licenseStatus) === 1
                && !String(this.licenseForm.licenseNumber || "").trim()) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم الرخصة مطلوب لاعتماد الشركة كمرخّصة.');
                return;
            }

            // سنة من رقمين تصير 0028 في حقل التاريخ — نوقفها قبل الإرسال
            const expiryProblem = this.expiryDateProblem(this.licenseForm.licenseExpiryOn, null, 'تاريخ انتهاء الرخصة');
            if (expiryProblem) {
                this.$helper.ShowMessage('warning', 'تنبيه', expiryProblem);
                return;
            }

            this.licenseSaving = true;
            this.$http.LicenseManufacturer({
                Id: this.licenseForm.id,
                LicenseStatus: Number(this.licenseForm.licenseStatus),
                LicenseNumber: this.licenseForm.licenseNumber || null,
                LicenseExpiryOn: this.licenseForm.licenseExpiryOn || null,
                LicenseNote: this.licenseForm.licenseNote || null,
            })
                .then((res) => {
                    this.licenseSaving = false;
                    this.licenseDialog = false;
                    this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم حفظ القرار.');
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.licenseSaving = false;
                    const msg = err.response && err.response.data ? err.response.data : 'تعذّر حفظ القرار.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        statusBadgeClass(status) {
            return Number(status) === 1 ? 'bg-label-success' : 'bg-label-warning';
        },
        statusLabel(status) {
            return Number(status) === 1 ? 'مفعل' : 'مخفي';
        },
        descriptionText(item) {
            return item && item.descriptions ? item.descriptions : 'بدون وصف إضافي';
        },
        manufacturerAvatarText(item) {
            const name = item && item.name ? item.name.trim() : '';
            if (!name) return 'MF';
            const parts = name.split(/\s+/).filter(Boolean);
            if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
            return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
        },
        tableRowNumber(index) {
            return ((Number(this.pageNo) - 1) * Number(this.pageSize)) + index + 1;
        },
        resetFormState() {
            this.ruleForm.Id = '';
            this.ruleForm.Name = '';
            this.ruleForm.Descriptions = '';
        },
        clearValidationState() {
            if (this.$refs.ruleForm && this.$refs.ruleForm.clearValidate) {
                this.$refs.ruleForm.clearValidate();
            }
        },
        showDrawer() {
            const el = document.getElementById('offcanvasManufacturerForm');
            if (el && window.bootstrap) {
                window.bootstrap.Offcanvas.getOrCreateInstance(el).show();
            }
        },
        hideDrawer() {
            const el = document.getElementById('offcanvasManufacturerForm');
            if (el && window.bootstrap) {
                const drawer = window.bootstrap.Offcanvas.getInstance(el) || window.bootstrap.Offcanvas.getOrCreateInstance(el);
                drawer.hide();
            }
        },
        onDrawerHidden() {
            this.clearValidationState();
        },
        openCreateDrawer() {
            this.drawerMode = 'create';
            this.SelectedItem = null;
            this.resetFormState();
            this.$nextTick(() => {
                this.clearValidationState();
            });
        },
        openEditDrawer(item) {
            this.drawerMode = 'edit';
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions || '';
            this.$nextTick(() => {
                this.clearValidationState();
                this.showDrawer();
            });
        },
        showRequestError(title, err) {
            if (err.response && err.response.data) {
                this.$helper.ShowMessage('error', title, err.response.data);
            } else {
                this.$helper.ShowMessage('error', title, 'حدث خطأ غير متوقع');
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || this.pageNo || 1;

            if (!this.Search) this.$blockUI.Start();
            this.$http.GetManufacturers(this.pageNo, this.pageSize, this.Search, this.sortBy, this.licenseFilter)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                    this.reviewLoad = response.data.reviewLoad || null;
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        submitDrawerForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.drawerMode === 'create') {
                        this.createManufacturer();
                    } else {
                        this.updateManufacturer();
                    }
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        createManufacturer() {
            this.ruleForm.Id = Number(0);
            this.$blockUI.Start();
            this.$http.AddManufacturers(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(1);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية الإضافة', err);
                });
        },

        updateManufacturer() {
            this.ruleForm.Id = Number(this.ruleForm.Id);
            this.$blockUI.Start();
            this.$http.EditManufacturers(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(this.pageNo);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية التعديل', err);
                });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من عملية تغيير حالة العرض؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusManufacturers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية التعديل', err);
                        });
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteManufacturers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية الحذف', err);
                        });
                }
            });
        },
    }
}
